<section class="about_section">
  <div class="about__container containerPersonal">
    <div class="about__data">
      <h1 class="home__title">Acerca de Corvus TID</h1>

      <p class="home__subtitle">
        <strong>Corvus TID</strong> es una empresa especializada en <strong>automatización, integración tecnológica y desarrollo de soluciones digitales</strong> 
        para los sectores comercial, industrial y doméstico. 
        Combinamos ingeniería, software y electrónica para transformar procesos, mejorar la eficiencia y ofrecer experiencias inteligentes a nuestros clientes.
        <br><br>
        Nuestro equipo está conformado por profesionales con amplia experiencia en desarrollo de software, arquitectura tecnológica, IoT y control industrial. 
        Hemos liderado proyectos que integran plataformas web, aplicaciones móviles y dispositivos conectados (balanzas, impresoras, sensores, sistemas de control), 
        garantizando soluciones robustas, escalables y seguras.
        <br><br>
        En Corvus TID impulsamos la transformación digital mediante la automatización de procesos, la conectividad total entre sistemas y el uso de tecnologías emergentes 
        que facilitan la toma de decisiones, el monitoreo en tiempo real y la gestión inteligente de recursos.
      </p>

      <div class="about__mission-vision">
        <div class="about__block">
          <h3>Misión</h3>
          <p>
            Impulsar la transformación digital de empresas, industrias y hogares mediante soluciones de automatización confiables, escalables y accesibles, 
            que mejoren la productividad, la eficiencia y la experiencia tecnológica de nuestros clientes.
          </p>
        </div>

        <div class="about__block">
          <h3>Visión</h3>
          <p>
            Ser líderes en innovación tecnológica en Latinoamérica, creando un ecosistema donde la automatización, la conectividad y la inteligencia digital 
            impulsen el crecimiento sostenible de las organizaciones y mejoren la calidad de vida en el hogar.
          </p>
        </div>
      </div>

      <div class="about__values">
        <h3>Valores</h3>
        <div class="about__values-grid">
          <div class="about__value-item">Innovación constante</div>
          <div class="about__value-item">Compromiso con la calidad</div>
          <div class="about__value-item">Transparencia y soporte</div>
          <div class="about__value-item">Orientación al cliente</div>
          <div class="about__value-item">Sostenibilidad tecnológica</div>
        </div>
      </div>
    </div>
  </div>
</section>
